// ============================================================
// ENVIRONMENT-AWARE API BASE URL
// Automatically switches between local XAMPP and live hosting
// ============================================================
const isLocal = ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);

const API_BASE = isLocal
    ? 'http://localhost/Syana/api/modules'              // LOCAL (XAMPP)
    : 'https://siyane.sudeshmaths.com/api/modules';     // PRODUCTION


const handleResponse = async (response) => {
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'API Error');
    }
    return response.json();
};

// Global Fetch Options for Session Support
const fetchOptions = (options = {}) => ({
    ...options,
    credentials: 'include', // Important for Sessions!
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authService = {
    login: (credentials) => fetch(`${API_BASE}/auth.php?action=login`, fetchOptions({
        method: 'POST',
        body: JSON.stringify(credentials)
    })).then(handleResponse),
    check: () => fetch(`${API_BASE}/auth.php?action=check`, fetchOptions()).then(handleResponse),
    logout: () => fetch(`${API_BASE}/auth.php?action=logout`, fetchOptions()).then(handleResponse),
    verifyPin: (pin) => fetch(`${API_BASE}/auth.php?action=verify_pin`, fetchOptions({
        method: 'POST',
        body: JSON.stringify({ pin })
    })).then(handleResponse),
    register: (data) => fetch(`${API_BASE}/auth.php?action=register`, fetchOptions({
        method: 'POST',
        body: JSON.stringify(data)
    })).then(handleResponse)
};

export const patientService = {
    getAll: () => fetch(`${API_BASE}/patients.php?action=get_all`, fetchOptions()).then(handleResponse),
    add: (data) => fetch(`${API_BASE}/patients.php?action=add`, fetchOptions({
        method: 'POST',
        body: JSON.stringify(data)
    })).then(handleResponse),
    update: (data) => fetch(`${API_BASE}/patients.php?action=update`, fetchOptions({
        method: 'POST',
        body: JSON.stringify(data)
    })).then(handleResponse),
    getHistory: (id) => fetch(`${API_BASE}/patients.php?action=get_history&id=${id}`, fetchOptions()).then(handleResponse),
    addHistory: (data) => fetch(`${API_BASE}/patients.php?action=add_history`, fetchOptions({
        method: 'POST',
        body: JSON.stringify(data)
    })).then(handleResponse),
    deleteHistory: (id, patientId) => fetch(`${API_BASE}/patients.php?action=delete_history&id=${id}&patient_id=${patientId}`, fetchOptions()).then(handleResponse),
    delete: (id) => fetch(`${API_BASE}/patients.php?action=delete&id=${id}`, fetchOptions()).then(handleResponse)
};

export const inventoryService = {
    getAll: () => fetch(`${API_BASE}/inventory.php?action=get_all`, fetchOptions()).then(handleResponse),
    upsert: (data) => fetch(`${API_BASE}/inventory.php?action=upsert`, fetchOptions({
        method: 'POST',
        body: JSON.stringify(data)
    })).then(handleResponse),
    delete: (id) => fetch(`${API_BASE}/inventory.php?action=delete&id=${id}`, fetchOptions()).then(handleResponse)
};

export const paymentService = {
    getAll: () => fetch(`${API_BASE}/payments.php?action=get_all`, fetchOptions()).then(handleResponse),
    add: (data) => fetch(`${API_BASE}/payments.php?action=add`, fetchOptions({
        method: 'POST',
        body: JSON.stringify(data)
    })).then(handleResponse),
    topUp: (data) => fetch(`${API_BASE}/payments.php?action=top_up`, fetchOptions({
        method: 'POST',
        body: JSON.stringify(data)
    })).then(handleResponse),
    getHistory: (id) => fetch(`${API_BASE}/payments.php?action=get_history&id=${id}`, fetchOptions()).then(handleResponse),
    updateDetails: (data) => fetch(`${API_BASE}/payments.php?action=update_details`, fetchOptions({
        method: 'POST',
        body: JSON.stringify(data)
    })).then(handleResponse)
};

export const deliveryService = {
    getAll: () => fetch(`${API_BASE}/deliveries.php?action=get_all`).then(handleResponse),
    updateStatus: (data) => fetch(`${API_BASE}/deliveries.php?action=update_status`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    }).then(handleResponse)
};
